export default __webpack_public_path__ + "static/media/calendar-date-range.3860a87e.svg";